import type { HbCountryRule } from '../types'

export function isBidderAllowedInCountry(rule: HbCountryRule | undefined, countryCode: string | undefined): boolean {
    if (!rule) {
        return true
    }

    const country = countryCode?.toUpperCase()

    if (rule.allow) {
        return country !== undefined && rule.allow.some((c) => c.toUpperCase() === country)
    }

    return country === undefined || !rule.deny.some((c) => c.toUpperCase() === country)
}
